import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import parse from "html-react-parser";

import "./pageListItem.scss";
import { arrowNavigationRight } from "../../assets/images/icons";
import {
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import { EVENTS } from "../../utils/constants";
import { createRedirectURL } from "../../utils/helperFunctions";

const PageListItem = ({
  allPagesData = {},
  uri = "",
  showIcon = false,
  categoryAndTag = "",
}) => {
  const { title = "", thumbnailUrl = "" } =
    allPagesData[uri] || {};

  return (
    <Link
      to={createRedirectURL(uri)}
      onClick={() => {
        ingestData({
          name: EVENTS.FAQ_CLICKED,
          data: {
            categoryAndTag,
            faqTitle: title,
          },
        });
      }}
    >
      <div
        className={
          "page-list-item" + (showIcon ? " icon-grid" : "")
        }
      >
        {showIcon && thumbnailUrl && (
          <div className="page-list-item-icon">
            <img src={thumbnailUrl} />
          </div>
        )}
        <div className="page-list-item-title">{title}</div>
        <div className="page-list-item-span">
          {parse(arrowNavigationRight)}
        </div>
      </div>
    </Link>
  );
};

PageListItem.propTypes = {
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
  showIcon: PropTypes.bool,
  categoryAndTag: PropTypes.string,
};

export default PageListItem;
